export const CREATE_JOB_REQUEST = 'CREATE_JOB_REQUEST'
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS'
export const CREATE_JOB_ERROR = 'CREATE_JOB_ERROR'
export const CREATE_JOB_RESET = 'CREATE_JOB_RESET'

export const LIST_JOBS_REQUEST = 'LIST_JOBS_REQUEST'
export const LIST_JOBS_SUCCESS = 'LIST_JOBS_SUCCESS'
export const LIST_JOBS_ERROR = 'LIST_JOBS_ERROR'
export const LIST_JOBS_RESET = 'LIST_JOBS_RESET'

export const SEARCH_SPECIFY_JOB_REQUEST = 'SEARCH_SPECIFY_JOB_REQUEST'
export const SEARCH_SPECIFY_JOB_SUCCESS = 'SEARCH_SPECIFY_JOB_SUCCESS'
export const SEARCH_SPECIFY_JOB_ERROR = 'SEARCH_SPECIFY_JOB_ERROR'
export const SEARCH_SPECIFY_JOB_RESET = 'SEARCH_SPECIFY_JOB_RESET'

export const UPDATE_JOB_REQUEST = 'UPDATE_JOB_REQUEST'
export const UPDATE_JOB_SUCCESS = 'UPDATE_JOB_SUCCESS'
export const UPDATE_JOB_ERROR = 'UPDATE_JOB_ERROR'
export const UPDATE_JOB_RESET = 'UPDATE_JOB_RESET'

export const UPLOAD_JOB_REQUEST = 'UPLOAD_JOB_REQUEST'
export const UPLOAD_JOB_SUCCESS = 'UPLOAD_JOB_SUCCESS'
export const UPLOAD_JOB_ERROR = 'UPLOAD_JOB_ERROR'
export const UPLOAD_JOB_RESET = 'UPLOAD_JOB_RESET'
